import React from 'react';
import { T } from '../traks';
import { A, R } from '../routes';
import { sort_market_ids } from '../markets';

const market_info = (() => {
	const list = [
		["US_STOCK", {text: <T>USA</T>, route: "/explore-us"}],
		["DK_STOCK", {text: <T>Denmark</T>, route: "/explore-cph"}],
		["SE_STOCK", {text: <T>Sweden</T>, route: "/explore-sto"}],
		//["NO_STOCK", {text: <T>Norway</T>}],
		["FI_STOCK", {text: <T>Finland</T>, route: "/explore-hel"}],
		["IS_STOCK", {text: <T>Iceland</T>, route: "/explore-ice"}],
		["DE_STOCK", {text: <T>Germany</T>, route: "/explore-xetra"}],
		["AT_STOCK", {text: <T>Austria</T>, route: "/explore-vie"}],
		["COMMODITIES", {text: <T>Commodity</T>, route: "/explore-commodities"}],
		["CRYPTOCURRENCIES", {text: <T>Crypto</T>, route: "/explore-crypto"}],
		["FOREX", {text: <T>Currency</T>, route: "/explore-bank"}],
	];

	let result = {};
	let sortkey = 1;
	for (const [id, info] of list) result[id] = {...info, sortkey: sortkey++};
	return result;
})();

export default (props) => {
	let elements = [];
	let markets = sort_market_ids([...props.markets]);
	for (let i = 0; i < markets.length; i++) {
		const market_id = markets[i];
		if (i > 0) elements.push(<span key={"bull"+i}><b> &bull; </b></span>);

		let market_element = <span key={market_id}>{market_info[market_id].text}</span>;
		const route = market_info[market_id].route;
		if (route) {
			market_element = <A key={market_id} className={props.market_link_class} href={R.href(route)}>{market_element}</A>;
		}
		elements.push(market_element);
	}
	return elements;
}



// WEBPACK FOOTER //
// ./src/c/Markets.js